import { NonEmptyArray } from "fp-ts/lib/NonEmptyArray";
import { literal, TLiteralCodec } from "../../shared/src/codecs/types/literal";
import { TUnionCodec, union } from "../../shared/src/codecs/types/union";
import { CasesDocumentTypes, TCasesDocumentType } from "../../domain/models/CaseDocumentType1";

export const CasesDocumentType: TUnionCodec<NonEmptyArray<TLiteralCodec<TCasesDocumentType>>> = union(
    CasesDocumentTypes.map((type) => literal(type)) as NonEmptyArray<TLiteralCodec<TCasesDocumentType>>
);